
import { post,get ,getJson} from '@/api/http';
/*查询观众列表 */

/**
 *
 * 在线用户列表搜索
 * @export
 * @param {*} data
 * @returns
 */
export function searchUserList(params) {
    return getJson({
        url: `/monitor/v1/webcast/user/list`,
        method: 'GET',
        params
    });
}


export const getOnlineuUserList = (params,token)=> getJson(`${config.cpp}monitor/v1/webcast/user/scope/list`,params,{token})

/**
 *
 * 踢出用户
 * @export
 * @param {*} data
 * @returns
 */
export function winkleUser(data,token) {
    return post(`${config.cpp}monitor/v2/webcast/${data.webcastId}/user/${data.userId}`,null,{ token });
}

/**
 *
 * 获取报名或者白名单用户的详情信息
 * @export
 * @param {*} data
 * @returns
 */
export function getUserInfo(params) {
    return get({
        url: `/monitor/v1/webcast/${params.webcastId}/${params.userId}/sign/info`,
        method: 'GET'
    });
}

// 获取观众列表：分页查询观众列表
export const getUserList = (query,token)=>getJson(`${config.cpp}monitor/v2/webcast/user/audience`,query,{ token })


// 主播将主控权转让给指定助手

export const giveupMainControl = (liveId,assistantId,token)=>getJson(`${config.cpp}monitor/v2/authority/giveup_main_control/${liveId}/${assistantId}`,null,{ token })

// 主控权用户将演示权交给嘉宾

export const tackBackShow = (liveId,uid,token)=>getJson(`${config.cpp}monitor/v2/authority/give_show/${liveId}/${uid}`,null,{ token })

//主播收回主控权

export const tackBackMainControl = (liveId,token)=>getJson(`${config.cpp}monitor/v2/authority/take_back_main_control/${liveId}`,null,{ token })

// 主播降级为嘉宾
export const giveUpHost = (targetUserId,token)=>post(`${config.cpp}monitor/v2/webcast/user/give_up_host/${targetUserId}`,null,{ token })
// 嘉宾升级成主播
export const beTheHost = (passCode, token)=>post(`${config.cpp}monitor/v2/webcast/user/be_the_host`,{ passCode },{ token })

//查询用户的权限集信息

export const getUserAuthority = (liveId,token)=>getJson(`${config.cpp}monitor/v2/authority/${liveId}`,null,{ token })

// 主播收回演示权

export const tackBackShowControl  = (liveId,token)=>getJson(`${config.cpp}monitor/v2/authority/tack_back_show/${liveId}`,null,{ token })

// 根据用户uid获取用户信息

export const getUidUserInfo = (uid,token) => getJson(`${config.cpp}monitor/v1/webcast/user/uid/${uid}`,null,{token})

// 查询场次用户在线时长统计

export const getUserTime = (liveId,query,token) => post(`${config.cpp}statistics/v1/online/conf/user/time/${liveId}`,query,{token})

//查询当前人的角色
export const getUserRole = (uid,token) => getJson(`${config.cpp}monitor/v1/webcast/user/uid/${uid}`,null,{token})

// getUserRole(this.userInfo.uid, this.$store.getters.liveToken).then(res => {
//     console.log(res,"获取角色信息")
//   });

